import React, { Component } from 'react';
import ReactPlayer from 'react-player'


import '../styles/components/video.scss';

import cross from '../assets/cross.svg';


export default class Video extends Component {

    render() {

        return (
          <div className={`video ${this.props.openState ? 'open ' : ''}`}>
            <div className="contents">
              <div className="video-wrapper">
                <ReactPlayer
                  playing={ this.props.playState }
                  url={ this.props.videoUrl }
                  className='react-player'
                  width="100%"
                  height="100%"
                />
              </div>
              <img src={ cross } alt='close icon' onClick={this.props.closeState} />
            </div>
          </div>
        );
    }
}
